<template>
  <div>
    <baidu-map class="bm-view" ak="Gbnhd8Q9XtedQAq0Rq9xHdXGGHEj4hV7" :center="center" :zoom="zoom" :showAddressBar="true" @ready="handler"  :scroll-wheel-zoom="true" >
      <bm-marker :position="center" :dragging="true" >
<!--        <bm-info-window :show="show" >我爱北京天安门</bm-info-window>-->
      </bm-marker>
    </baidu-map>
  </div>
</template>

<script>
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import {BmMarker} from 'vue-baidu-map'
    export default {
        name: "demo",
        components: {
            'baidu-map':BaiduMap,
            'bm-marker':BmMarker,

        },
        props:{
            center:{
                type:Object,
                required:true
            }
        },
        data: () => ({
            // center: {lng:'',lat:''},
            zoom: 3,
            show: true
        }),
        methods: {
            handler ({BMap, map}) {
                // console.log(BMap, map)
                console.log(this.center)

                // this.center= "上海市国权北路1600号湾谷科技园A4座1209室"
                this.zoom = 16

            }
        }
    }
</script>

<style scoped>
  .map {
    width: 100%;
    height: 400px;
  }
  .bm-view {
    width: 90%;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/baiduMap/baiduMap.vue